import { isEqual } from 'lodash';
export const validateSalesReturnForm = (data = {}, defaultValues = {}) => {
  const checkEquality = Boolean(isEqual(data, defaultValues));
  let checkout = true;

  if (!checkEquality) {
    checkout = false;
  }
  return { checkout };
};
